export const MyLiNKQueryKeys = {
    AllCollections: "AllCollections",
    BookmarkCountBy: "BookmarkCountBy",
    BookmarkDetail: "BookmarkDetails",
    Bookmarks: "Bookmarks",
    BookmarksByColor: "BookmarksByColor",
    BookmarksByCollectionId: "BookmarksByCollectionId",
    BookmarksByPublicationCode: "BookmarksByPublicationCode",
    CollectionDetail: "CollectionDetail",
    CollectionsByBookmarkId: "CollectionsByBookmarkId",
    PublicationDetail: "PublicationDetail",
    SectionForBookmark: "SectionForBookmark",
    TableForBookmark: "TableForBookmark",
    UserCollectionsBookmarks: "UserCollectionsBookmarks",
};
